import React from 'react'
import { Outlet } from "react-router-dom"
import Footer from './Footer';
import Navbar from './Navbar'
import BackgroundImage from '../assets/images/background.png'

const Layout = () => {
  return (
  <>
      <div 
        className='w-full fixed top-[15vh] left-0 h-[200vh] opacity-[0.04] z-[-1]'
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundRepeat: 'repeat-y',
          backgroundSize: '120%',
          backgroundPosition: 'center center'
        }}
      >
      </div>
      
      <Navbar />
      <div className="max-w-[1440px] mx-auto pt-20" id='main' >
          <Outlet />
      </div>
      <Footer/>
  </>
  )
}

export default Layout
